import { render, staticRenderFns } from "./controlAccordion.vue?vue&type=template&id=03f09ea9&scoped=true"
import script from "./controlAccordion.vue?vue&type=script&lang=js"
export * from "./controlAccordion.vue?vue&type=script&lang=js"
import style0 from "./controlAccordion.vue?vue&type=style&index=0&id=03f09ea9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f09ea9",
  null
  
)

export default component.exports